/* eslint-disable */
export default {
  set: 'Set',
  findReplace: 'FindReplace',
  append: 'Append',
  prepend: 'Prepend',
  toTitleCase: 'ToTitleCase',
  toLowerCase: 'ToLowerCase',
  toSentenceCase: 'ToSentenceCase'
};

